/**
 * <cevo-signup-band> – remembers a sign-up made through the band above the footer.
 * Markup and settings: sections/cevo-signup-band.liquid. The form inside is <cevo-optin-form>
 * (cevo-optin-form.js), which does the validation, the bot check and the sending.
 *
 * After a sign-up this browser is marked as signed up for a year, in the same storage entry the
 * pop-up reads, so neither the band nor the pop-up shows again. The band hides itself on the next
 * page load (an inline script in the section, so it never flashes).
 */
(() => {
  if (customElements.get('cevo-signup-band')) return;

  // Shared with cevo-signup-popup.js and the inline script in sections/cevo-signup-band.liquid.
  const STORAGE_KEY = 'cevo-signup-popup';
  const DAY_MS = 24 * 60 * 60 * 1000;
  const SIGNED_UP_DAYS = 365;
  const SUCCESS_EVENT = 'cevo-optin:success';

  /** localStorage can be missing or throw (private mode, blocked storage); nothing is lost but the memory. */
  function rememberSignUp() {
    try {
      const saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
      const until = Date.now() + SIGNED_UP_DAYS * DAY_MS;
      const current = saved && typeof saved === 'object' ? saved : {};
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...current, hiddenUntil: until, signedUpUntil: until }));
    } catch {
      // Without storage the visitor may simply see the band or the pop-up again.
    }
  }

  /** Custom events for GA4 (dataLayer) and Shopify customer events, where either is present. */
  function track(name, detail) {
    window.dataLayer?.push({ event: name, ...detail });
    window.Shopify?.analytics?.publish?.(name, detail);
  }

  class CevoSignupBand extends HTMLElement {
    connectedCallback() {
      this.addEventListener(SUCCESS_EVENT, this.onSignedUp);
    }

    disconnectedCallback() {
      this.removeEventListener(SUCCESS_EVENT, this.onSignedUp);
    }

    onSignedUp = () => {
      if (this.hasAttribute('data-design-mode')) return;
      rememberSignUp();
      track('cevo_band_signup', {});
    };
  }

  customElements.define('cevo-signup-band', CevoSignupBand);
})();
